import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { ELayoutType } from '../../../../../../../json_query';
import { changeLayoutType } from '../../../../../../state/advanced/layout';
import { changeWithLayout } from '../../../../../../state/with_layout';
import { isRoomTypeAvailable, isWithLayoutAvailable } from '../../../../../../../utils/layout';

import { Layout as LayoutComponent } from './layout';

export const Layout = connect(
  (state: IAppState) => ({
    isWithLayoutAvailable: isWithLayoutAvailable(state.filters.jsonQuery),
    isRoomTypeAvailable: isRoomTypeAvailable(state.filters.jsonQuery),
    jsonQuery: state.filters.jsonQuery,
  }),
  (dispatch: Dispatch) => ({
    onWithLayoutChanged: (value: boolean) => {
      dispatch(changeWithLayout(value));
    },
    onLayoutChanged: (value: ELayoutType) => {
      dispatch(changeLayoutType(value));
    },
  }),
)(LayoutComponent);
